import { Tooltip } from '@material-ui/core';
import { Avatar } from 'copilot-design-system';

import { getInitials } from 'src/utils/UserUtils';

type AvatarData = {
  name: string;
  src: string;
  fallbackColor: string;
  companyAvatar?: Omit<AvatarData, 'companyAvatar'>;
};
type Props = {
  user: AvatarData;
  size?: number;
};

export const UserCompanyAvatar = ({ user, size = 28 }: Props) => {
  return (
    <div className="flex items-center gap-3 relative">
      <Avatar
        text={getInitials(user.name)}
        src={user.src}
        fallbackColor={user.fallbackColor}
        variant="circle"
        size="sm"
        style={{
          width: size,
          height: size,
        }}
        alt={user.name}
      />
      {user.companyAvatar && (
        <Tooltip title={user.companyAvatar.name} placement="right">
          <Avatar
            className="absolute"
            style={{
              width: size / 2,
              height: size / 2,
              bottom: -2,
              right: -2,
            }}
            text={getInitials(user.companyAvatar.name)}
            src={user.companyAvatar.src}
            fallbackColor={user.companyAvatar.fallbackColor}
            variant="rounded"
            size="sm"
          />
        </Tooltip>
      )}
    </div>
  );
};
